import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { _T } from '../src/Localization';
export const ErrorElement = () => {
    return (React.createElement(Result, { status: "500", title: "500", subTitle: "Sorry, something went wrong.", extra: React.createElement(Link, { to: window.location.origin },
            React.createElement(Button, { type: "primary" }, _T('login.home'))) }));
};
